import React from 'react';
import { View } from 'react-native';
import ContactListScroll from './ContactListScroll';
import SearchContactHeadLine from './SearchContactHeadLine';

//= ========================================================================

const SearchContactList = ({
  globJSON,
  subCategoryId,
  simPlatform,
  withSelected,
  withExpand = false,
  withMe = false,
  withCircle = false,
}) => (
  <View>
    <SearchContactHeadLine
      globJSON={globJSON}
      subCategoryId={subCategoryId}
      simPlatform={simPlatform}
      text={globJSON.configurations.services[subCategoryId].recipient.search_contact_hint}
    />
    <ContactListScroll
      globJSON={globJSON}
      simPlatform={simPlatform}
      withSelected={withSelected}
      withExpand={withExpand}
      withMe={withMe}
      withCircle={withCircle}
    />

  </View>
);
export default SearchContactList;
